import '../../static/css/custom.css';
import Layout from '../components/common/layout-new';
import { partnerLists } from '../../static/partner-list';
import PropTypes from 'prop-types';
import RedEye from '../components/common/red-eye';
import Seo from '../components/common/seo';
import { navigate, withPrefix } from 'gatsby';
import React, { useEffect } from 'react';

const NotFoundPage = ({ location, pageContext }) => {
  const { partnerListsData } = pageContext;
  const { partnerItem } = partnerLists;
  //const sortedPartnerList = partnerItem.sort((arrayA, arrayB) => arrayA.partnerName.localeCompare(arrayB.partnerName));
  const essexSuffolkUrl = partnerItem.filter(partners => partners.partnerName === 'Essex & Suffolk Water')[0].partnerUrl;
  const northumbrianUrl = partnerItem.filter(partners => partners.partnerName === 'Northumbrian Water')[0].partnerUrl;

  const basePath = process.env.URL_PREFIX || '';
  useEffect(() => {
    checkNavigation();
  }, []);
  const checkNavigation = () => {
    if (location.pathname.split('/').length === 3) {
      navigate(withPrefix(`${basePath}/nodapitem`));
    }
  };
  return (
    <Layout pageContext page="NotFound" notFound="NotFound">
      <Seo title="Oops, the page you're looking for has not been found..." />
      <div id="content-block" className="content-block-on not-found">
        <div className="container">
          <div className="row" />
          <hr />
          <div className="row">
            <div className="col-md-8">
              <div className="row">
                <div className="col-md-12">
                  <div className="page-header">
                    <h1>Oops, the page you're looking for has not been found...</h1>
                  </div>
                  {partnerListsData && <><p>We're sorry, the offer you're looking for may have expired or you might have entered the web address incorrectly, so please try again.</p>
                    <p>To see the current offer, please select your water or energy company below:</p></>}
                  {!partnerListsData && <><p>We're sorry, the page you're looking for may have moved (or you might have entered the web address incorrectly).</p>
                    <p>If you'd like some help, either connect with one of our Live Chat team or please call us on the following number.
                      Lines are open 8am to 8pm weekdays, 8am to 4pm Saturday and 10am to 4pm Sunday.</p><a href="tel:0800 247 999" className="phone-button btn btn-default">
                      <span className="icon icon-phone-dark"> </span> 0800 247 999 *
                    </a></>}
                  {partnerListsData && <ul className="partner-name">
                    {partnerListsData.filter(opt => !opt.name.toLowerCase().includes('homeserve')).map((partner, index) => (
                      <li key={index} >
                        <a href={partner.name === 'Essex & Suffolk Water' ? essexSuffolkUrl : partner.name === 'Northumbrian Water' ? northumbrianUrl : `${basePath}/${partner.name.replace(/\W+/g, '-').toLowerCase()}`}
                          role="link">{partner.name}</a>
                        {/* <a href={`${basePath}/${partner.name.replace(/\W+/g, '-').toLowerCase()}`} role="link">{partner.name}</a> */}
                      </li>
                    ))}
                    <p>To see the current offer from HomeServe, <a href={`${process.env.MAIN_SITE_URL}/insurance/plumbing-drainage-cover`}>click here</a>.</p>
                  </ul>}
                </div>
              </div>
              <hr />
            </div>
            <div className="col-md-4">
              <div className="well" id="liveChat">
                <h3 className="homeserve_thick">Chat to us</h3>
                <p />
                <p />
                <div className="measure-me">
                  <p>We're available:</p>
                  <ul className="arrow-links">
                    <li>Weekdays 8am - 8pm</li>
                    <li>Saturday 8am - 4pm</li>
                    <li>Sunday 10am - 4pm</li>
                  </ul>
                  <div id="lpButtonDiv-embedded" />
                </div>
              </div>
            </div>
            <div className="col-xs-12">
              <span className="visible-xs-block hidden-md hidden-lg">
                <hr />
              </span>
              {!partnerListsData && <p><small><span id="caveat-phone">*</span>Calls may be recorded for quality control and training purposes. Calls to 0800 numbers are free from landlines and mobile phones, and will not be taken from your mobile phone inclusive minutes.</small></p>}
            </div>
          </div>
        </div>
      </div>
      <RedEye page="nodap" />
    </Layout >
  );
};
export default NotFoundPage;
NotFoundPage.propTypes = {
  pageContext: PropTypes.object,
  location: PropTypes.object
};
